import { Injectable } from "@angular/core";
import { CookieService } from "angular2-cookie/core";
import { Http, RequestOptions } from "@angular/http";

import { BehaviorSubject, Observable } from "rxjs";

import { CmhUser } from "../model/cmhuser";
import { ServiceUtilities } from './service-utilities';
import { HxMetadata } from "../model/hx-metadata";

@Injectable()
export class CurrentUserService {
    private TOKEN_NAME: string = 'Bearer';
    private USER_PROFILE_NAME: string = 'CLU';
    //private loginUrl = 'http://dev.cmhconnection.com/#!/login';
    private cmhBaseUrl: string;


    currentUser$: BehaviorSubject<any> = new BehaviorSubject(null);
    mchUserStatus$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    userSet$: BehaviorSubject<boolean> = new BehaviorSubject(false);    

    changeRetailerModalViewStatus$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(
        private cookieService: CookieService,
        private http: Http,
        private serviceUtils: ServiceUtilities
    ) {
        this.cmhBaseUrl = this.cookieService.get('cmhBaseUrl');
    }

    removeUserTokenRedirect() {
        this.cookieService.remove(this.TOKEN_NAME);
        window.location.href = `${this.cmhBaseUrl}/#!/login`;
    }

    removeUserTokenAndProfile() {
        this.removeUserTokenRedirect();
        localStorage.removeItem(this.USER_PROFILE_NAME);
    }

    setUserToken(token: string): void {
        this.removeUserToken();
        this.cookieService.put(this.TOKEN_NAME, token, { path: '/' })
    }

    removeUserToken(): void {
        //this.cookieService.remove(this.TOKEN_NAME, { path: '/' });
        this.cookieService.remove('Bearer');
    }

    setCurrentUser(user: any) {
        let cmhUser = new CmhUser();
        cmhUser.CmhUserId = user.cmhUserId;
            cmhUser.UserName = user.userName;
            cmhUser.FirstName = user.firstName;
            cmhUser.LastName = user.lastName;
            cmhUser.IsActive = user.isActive;
            cmhUser.IsInternal = user.isInternal;
            cmhUser.IsPlantUser = user.isPlantUser;
            cmhUser.CurrentRetailer = user.currentRetailer ? user.currentRetailer.name : "";
            cmhUser.Roles = user.roles;
            cmhUser.AvailableRetailers = user.availableRetailers;
            cmhUser.availableRetailers = user.availableRetailers;
            cmhUser.CmhUserRoles = user.cmhUserRoles;
            cmhUser.CurrentRetailer = user.currentRetailer;
            cmhUser.PasswordLastChanged = user.passwordLastChanged;
            cmhUser.CurrentRetailerNumber = user.currentRetailer ? user.currentRetailer.retailerNumber : "";
            cmhUser.availableFacilities = user.availablePlants;
            cmhUser.fullName = `${user.firstName} ${user.lastName}`;
            cmhUser.retailerName = user.currentRetailer.name;
            cmhUser.retailerNumber = user.currentRetailer.retailerNumber;
            cmhUser.cmhUser = user.cmhUserId;

        if (cmhUser.CurrentRetailer && cmhUser.CurrentRetailer['retailerNumber']) {
            // must get a second time so that we can get the retailer type
            return this.getRetailer(cmhUser.CurrentRetailer['retailerNumber']).subscribe((r) => {
                cmhUser.CurrentRetailer['retailerType'] = r.retailerType;
                localStorage.setItem("CLU", btoa(JSON.stringify(cmhUser)));
                this.userSet$.next(true);
            });
        }
        else {
            localStorage.setItem("CLU", btoa(JSON.stringify(cmhUser)));
            this.currentUser$.next(cmhUser);
        }
    }

    get authUrlCookie() {
        return this.cookieService.get('authUrl');
    }

    get apiUrlCookie() {
        return this.cookieService.get('apiUrl');
    }

    private getRetailer(retailerNumber: string) {
        let options: RequestOptions = this.serviceUtils.getStandardHeaderOptions();
        //let bearer = this.cookieService.get('Bearer');
        //options.headers.append('authorization', `bearer ${bearer}`);
        let url = `${this.apiUrlCookie}/api/Retailer?retailerNumber=${retailerNumber}`;
        return this.http.get(url, options)
            .map(x => x.json());
    }
    getPartnerPortal(): Observable<boolean> {
        let options: RequestOptions = this.serviceUtils.getStandardHeaderOptions();

        const retailerNumber = this.currentUser$.value.currentRetailer.retailerNumber;
        let url = `${this.apiUrlCookie}/api/service/hxstatus/${retailerNumber}`;

        return this.http.get(url, options)
        .map((result: any) => {
            const hxMetadata = <HxMetadata>result.json() || new HxMetadata();
            return hxMetadata.partnerPortal;
        });
     }
     
    public canUserViewProspects(roles: Array<string>): boolean {
        return roles == null
            ? false
            : roles.indexOf('Prospects_User') > 0;
    }

    public setLockQuoteStatusOnRedirectOrClose(quoteId: number, locked: boolean, currentUserId: number) {
        let options = this.http.request;
        quoteId = quoteId !== undefined && quoteId !== null ? quoteId : 0;
        currentUserId = currentUserId !== undefined && currentUserId !== null ? currentUserId : 0;

        let xhr = new XMLHttpRequest();
        xhr.open("POST", (`${this.getBaseURLFromCookie()}/api/quotes/set-lock-status/${quoteId}/${locked}/${currentUserId}`), false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.setRequestHeader("Authorization", 'bearer ' + this.cookieService.get('Bearer'));
        xhr.send();

    }

    private getBaseURLFromCookie(): string {
        let name = 'baseURL';
        let baseURL = ''
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) { baseURL = match[1].toString(); }

        return baseURL;
    }

    public getUserType(isPlantUser: boolean, isInternalUser: boolean): string {
        
        if (isPlantUser == null || isInternalUser == null)
        {
            return "Unknown User Type";
        }

        if (isPlantUser === true)
        {
            return "Facility User";
        }
    
        if (isInternalUser === true)
        {
            return "Clayton Retail User";
        }
        else
        {
            return "Independent Retail/Park User";
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/current-user.service.ts